let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4K9Le")).then(() => parcelRequire('5g9T5'));